export class OrgaoDoJudiciario {

  Id: number;
  Nome: string;
  Contato: string;
  Telefone: string;
  Celular: string;
  Ramal: string;
  Fax: string;
  Site: string;
  Email: string;
  Ativo: boolean;

  constructor() {
    this.Id = 0;
    this.Nome = '';
    this.Contato = '';
    this.Telefone = '';
    this.Ramal = '';
    this.Fax = '';
    this.Site = '';
    this.Email = '';
    this.Ativo = true;
  }
}
